import {
  Card,
  CardContent,
  Box,
  Typography,
  Divider,
  LinearProgress,
  Tooltip,
} from "@mui/material";
import {
  Schedule,
  TrendingDown,
  CheckCircle,
  AccessTime,
} from "@mui/icons-material";

const TaskInsightsCard = ({
  deletionRate,
  tasksDeleted,
  tasksCreated,
  nonAdminTasksCreated,
  nonAdminTasksCompleted,
}) => {
  // Calculate additional metrics
  const completionRate =
    nonAdminTasksCreated > 0
      ? Math.round((nonAdminTasksCompleted / nonAdminTasksCreated) * 100)
      : 0;
  const activeTasks = nonAdminTasksCreated - nonAdminTasksCompleted;
  const deletedTasksCount = Math.round(
    (tasksDeleted / tasksCreated) * tasksCreated,
  );

  // Determine if task health is good or needs attention
  const taskHealthy = completionRate > 40;

  return (
    <Card elevation={2}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Schedule color="error" sx={{ mr: 1 }} />
          <Typography variant="h6" fontWeight="bold">
            Task Insights
          </Typography>
        </Box>

        {/* Completion Rate */}
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Completion Rate
            </Typography>
            <Typography variant="body2" fontWeight="bold" color="success.main">
              {completionRate}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={completionRate}
            color={taskHealthy ? "success" : "warning"}
            sx={{ height: 8, borderRadius: 4 }}
          />
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            {nonAdminTasksCompleted} of {nonAdminTasksCreated} tasks completed
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Task Breakdown */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" fontWeight="bold" sx={{ mb: 2 }}>
            Task Status
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {/* Completed Tasks */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CheckCircle sx={{ fontSize: 18, color: "success.main" }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  Completed
                </Typography>
              </Box>
              <Typography variant="body2" fontWeight="bold">
                {nonAdminTasksCompleted}
              </Typography>
            </Box>

            {/* Active Tasks */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <AccessTime sx={{ fontSize: 18, color: "warning.main" }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  In Progress
                </Typography>
              </Box>
              <Typography variant="body2" fontWeight="bold">
                {activeTasks}
              </Typography>
            </Box>

            {/* Deleted Tasks */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TrendingDown sx={{ fontSize: 18, color: "error.main" }} />
              <Box sx={{ flex: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  Deleted ({deletionRate}%)
                </Typography>
              </Box>
              <Typography variant="body2" fontWeight="bold">
                {tasksDeleted}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />
      </CardContent>
    </Card>
  );
};

export default TaskInsightsCard;
